module.exports = __webpack_public_path__ + "img/delete.dc04a5d6.png";